import { memo, type ReactNode } from "react";
import Modal from "../../../../../common/components/Modal";
import { IMG_OPTIME_PARTS } from "../../../../../utils/url/staticResources";
import { useTranslation } from "react-i18next";
import { Alert } from "~/common/m3/Alert/Alert";
import { Stacker } from "~/common/components/Stacker/Stacker";

interface Props {
  onClose: () => void;
  closeButton: ReactNode;
  continueButton: ReactNode;
}

const OptimeInfoPopup = (props: Props) => {
  const { onClose, closeButton, continueButton } = props;
  const { t } = useTranslation();
  return (
    <Modal
      onClose={onClose}
      title={t("optimePopup.completeOptime")}
      footerChildren={
        <Stacker direction={"row"} gap={8}>
          {closeButton}
          {continueButton}
        </Stacker>
      }
    >
      <Alert severity="info">{t("cartPage.optimePopup.info.text")}</Alert>
      <div className="scha__optime-popup__img-container">
        <img className={"w-100"} src={IMG_OPTIME_PARTS} />
      </div>
      <div className="scha__optime-popup__prod-names">
        <div className="scha__optime-popup__prod-names__single-name">{t("optimePopup.product.sensor")}</div>
        <div className="scha__optime-popup__prod-names__single-name">{t("optimePopup.product.gateway")}</div>
        <div className="scha__optime-popup__prod-names__single-name">{t("optimePopup.product.dst")}</div>
      </div>
    </Modal>
  );
};

export default memo(OptimeInfoPopup);
